import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BottomOverlay from "../components/BottomOverlay";
import backArrow from "../assets/dashboardBackArrow.png";
import DashboardToggleComponent from "../components/DashboardToggleComponent";
import DashboardSlideBarComponent from "../components/DashboardSlideBarComponent";
import LineChartComponent from "../components/LineChartWithCustomDesgin";
import SimpleLineChart from "../components/SimpleLineChart";
import AssessmentCommonDropdown from "../../../components/AssessmentSelection_Dropdown";
import { AssessmentDetails } from "../../../features/recommendation/textRecommendation/data/response/AssesResponse";
import SkillScorePage from "../../../features/student_dashboard/skill_score/pages/SkillScore_Pages";
import Logger from "../../../utils/Logger";
import { LocalStorage } from "../../../utils/Utils";
import { useApi } from "../../../service/ApiContext";
import Loader from "../../../utils/Utils";
import {
  AssessmentData,
  ConceptScoreData,
} from "../../../features/student_dashboard/skill_score/interface/ScoreResponse_Interface";
import StudentDashBoardClient from "../../../features/student_dashboard/data/apiclient/StudentDashBoard";
import ChartComponent from "../../../features/student_dashboard/industry_score/components/ScoreChartComponent";
import { OverviewDataResponse } from "../data/interface/AssessmentChartInterfaces";
import { ConceptScoreDataResponse } from "../data/interface/ConceptPerformanceInterfaces";
import CommonUtils from "../../../utils/Common_Utils";
import { Button } from "react-bootstrap";
import AdvancedFilter from "../components/AdvanceFilterPopover";
import assesClient from "../../../features/recommendation/textRecommendation/data/api/AssesNameClient";
import filterIcon from "../assets/filterIcon.png";
import downArrow from "../assets/downArrowIcon.png";
import illustratorImg from "../assets/chartillustratorImg.png";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import {
  setActiveTab,
  setSelectedItem,
} from "../data/redux/ProgramAdvanceFilterRedux";
import OverallResultCardPage from "../../../features/student_dashboard/industry_score/pages/OverallResultCardPage";
import VideoExportApiCallServices from "../data/api services/VideoExportApiServices";
import {
  AssessmentExportResponse,
  FilterFieldNested,
  FilterGroup,
  GradedPopQuizItem,
  GradedPopQuizResponse,
  ProgramList,
  ProgramListResponse,
  SubjectList,
  SubjectResponse,
} from "../data/interface/AdvancedFilterReponse";
import SimpleProgramSubjectFilter from "../components/AdvanceFilterPopoverForProgramPerformance";
import {
  setgradedProgram,
  setSelectedProgram,
  setSelectedSubject,
  setSelectedToggle,
  setSubjects,
  SubjectOption,
} from "../data/redux/GradedPopQuizRedux";
import { useAlert } from "../../../components/AlertContextComponent";
import { videolandingPageRequest } from "../../../features/recommendation/vedio-recommendation/data/request/VideoLandingPageRequest";
import { VideoReportClient } from "../data/client/VideoReportClient";
import strings from "../../../utils/Strings";
import ExportComponent from "../components/ExportComponent";
import GradedPopQuizCardPage from "../../../features/student_dashboard/industry_score/pages/GradedPopQuizCardPage";
import ZeroBulb from "../../../features/inventory_dashboard/assets/bulb_images/bulb0.png";
import LowRedBulb from "../../../features/inventory_dashboard/assets/bulb_images/lowred.png";
import RedBulb from "../../../features/inventory_dashboard/assets/bulb_images/RedBulb.png";
import GreenBulb from "../../../features/inventory_dashboard/assets/bulb_images/GreenBulb.png";
import LowYellowBulb from "../../../features/inventory_dashboard/assets/bulb_images/LowYellowBulb.png";
import "../../../features/student_dashboard/industry_score/styles/OverallResultCardStyles.css";
import VideoImg from "../assets/GPVideoImg.png";
import DocImg from "../assets/documentIcon.png";

import LearnerImg from "../assets/GPLearnerImg.png";
import BlueHorizontalDivider from "../../../features/recommendation/recommendation_industry_view/components/Blue_Horizontal_Divider";
import CloseIcon from "../assets/GPcloseIcon.png";
import BlueArrowImg from "../assets/blueArrow.png";
import notificationIcon from "../assets/notificationIcon.svg";
import cancelIcon from "../assets/cancelIcon.svg";
import faqIcon from "../assets/faqIcon.svg";
import notifyCancel from "../assets/notifyCancel.svg";
import motivationIcon from "../assets/motivationIcon.svg";
import { Console } from "node:console";
import IndustryAssessmentResultDropdown from "../components/IndustryAssessmentResultDropdown";

interface AssessmentItem {
  candidate_id: string;
  assessment_id: string;
  assessment_name: string;
  timestamp: string;
}

interface AssessmentResponse {
  assessment_names: AssessmentItem[];
}
const ViewDetailsOverlay: React.FC = () => {
  // const linecChartConfigs = [
  //   {
  //     title: "Learning & Innovation",
  //     data: [
  //       { stage: "Basic Skill-Up", criticalThinking: 60, communication: 60, collaboration: 40, creativity: 80 },
  //       { stage: "Intermediate Skill-Up", criticalThinking: 55, communication: 40, collaboration: 28, creativity: 15 },
  //       { stage: "Advance Skill-Up", criticalThinking: 90, communication: 80, collaboration: 50, creativity: 60 },
  //     ],
  //     skills: [
  //       { key: "criticalThinking", label: "Critical Thinking", color: "#ffca64" },
  //       { key: "communication", label: "Communication", color: "#0067ff" },
  //       { key: "collaboration", label: "Collaboration", color: "#9239e0" },
  //       { key: "creativity", label: "Creativity & Innovation", color: "#24c782" },
  //     ],
  //   },
  // ];
  const colorLinePalette = [
    "#ffa300",
    "#468ff8",
    "#9eb82b",
    "#07A79d",
    "#ff6f61",
    "#6a4c93",
  ];

  type lineSkill = {
    key: string;
    label: string;
    color?: string; // ✅ make color optional
  };

  const addColorsToLineSkills = (skills: lineSkill[]) =>
    skills.map((skill, index) => ({
      ...skill,
      color: skill.color || colorLinePalette[index % colorLinePalette.length], // use API color if exists
    }));

  const linecChartConfigs = [
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
  ];

  // ✅ Preprocess configs
  const configsWithColorsforSkill = linecChartConfigs.map((config) => ({
    ...config,
    skills: addColorsToLineSkills(config.skills),
  }));
  const lineAreaChartConfigsforcurriProg = [
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 75,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 8,
          creativity: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 95,
        },
      ],
      skills: [
        // { key: "criticalThinking", label: "Critical Thinking", color: "#FDB82B" },
        // { key: "communication", label: "Communication", color: "#3D9FF5" },
        // { key: "collaboration", label: "Collaboration", color: "#B0BF1A" },
        {
          key: "creativity",
          label: "Creativity & Innovation",
          color: "#24c782",
        },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 75,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 8,
          creativity: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 95,
        },
      ],
      skills: [
        // { key: "criticalThinking", label: "Critical Thinking", color: "#FDB82B" },
        // { key: "communication", label: "Communication", color: "#3D9FF5" },
        // { key: "collaboration", label: "Collaboration", color: "#B0BF1A" },
        {
          key: "creativity",
          label: "Creativity & Innovation",
          color: "#24c782",
        },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 75,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 8,
          creativity: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 95,
        },
      ],
      skills: [
        // { key: "criticalThinking", label: "Critical Thinking", color: "#FDB82B" },
        // { key: "communication", label: "Communication", color: "#3D9FF5" },
        // { key: "collaboration", label: "Collaboration", color: "#B0BF1A" },
        {
          key: "creativity",
          label: "Creativity & Innovation",
          color: "#24c782",
        },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 75,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 8,
          creativity: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 0,
          communication: 0,
          collaboration: 0,
          creativity: 95,
        },
      ],
      skills: [
        // { key: "criticalThinking", label: "Critical Thinking", color: "#FDB82B" },
        // { key: "communication", label: "Communication", color: "#3D9FF5" },
        // { key: "collaboration", label: "Collaboration", color: "#B0BF1A" },
        {
          key: "creativity",
          label: "Creativity & Innovation",
          color: "#24c782",
        },
      ],
    },
  ];

  const colorPalette = [
    "#ffa300",
    "#468ff8",
    "#9eb82b",
    "#07A79d",
    "#ff6f61",
    "#6a4c93",
  ];

  type Skill = {
    key: string;
    label: string;
    color?: string; // ✅ make color optional
  };

  const addColorsToSkills = (skills: Skill[]) =>
    skills.map((skill, index) => ({
      ...skill,
      color: skill.color || colorPalette[index % colorPalette.length], // use API color if exists
    }));

  const lineAreaChartConfigs = [
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
    {
      title: "Learning & Innovation",
      data: [
        {
          stage: "Basic Skill-Up",
          criticalThinking: 60,
          communication: 60,
          collaboration: 40,
          creativity: 80,
          EnvironmentLiteracy: 80,
        },
        {
          stage: "Intermediate Skill-Up",
          criticalThinking: 55,
          communication: 40,
          collaboration: 28,
          creativity: 15,
          EnvironmentLiteracy: 60,
        },
        {
          stage: "Advance Skill-Up",
          criticalThinking: 90,
          communication: 80,
          collaboration: 50,
          creativity: 60,
          EnvironmentLiteracy: 25,
        },
      ],
      skills: [
        { key: "criticalThinking", label: "Critical Thinking" },
        { key: "communication", label: "Communication" },
        { key: "collaboration", label: "Collaboration" },
        { key: "creativity", label: "Creativity & Innovation" },
        { key: "EnvironmentLiteracy", label: "Environment Literacy" },
        { key: "STEM Awareness", label: "STEM Awareness" },
      ],
    },
  ];

  // ✅ Preprocess configs
  const configsWithColors = lineAreaChartConfigs.map((config) => ({
    ...config,
    skills: addColorsToSkills(config.skills),
  }));
  const api = useApi();
  const navigate = useNavigate();
  const { state } = useLocation() as { state: any };
  const [chartConfigs, setChartConfigs] = useState<any[]>([]);
  const [chartCPConfigs, setChartCPConfigs] = useState<any[]>([]);
  const [showFilter, setShowFilter] = useState(false); // <-- define here
  const { showAlert } = useAlert();
  const [showFilterGP, setShowFilterGP] = useState(false); // <-- define here
  const [resetGP, setresetGP] = useState(true); // <-- define here

  const dispatch = useDispatch();
  type ToggleType =
    | "Pop-Quiz"
    | "Assessments Results"
    | "Progress Timeline"
    | "Skills Timeline";
  // const [selectedToggle, setSelectedToggle] = useState<any>("Pop-Quiz");

  const selectedToggle = useSelector(
    (state: RootState) => state.advancedFilterGradedPopQuiz.selectedToggle,
  );

  const [selectedSlideBar, setSelectedSlideBar] = useState("Overall Progress");
  const [assessmentId, setSelectedAssessmentId] = useState(
    state?.assessmentId || "",
  );

  const [selectedSlideBarRes, setSelectedSlideBarRes] =
    useState("Overall Results");
  const [componentsToShow, setComponentsToShow] = useState<JSX.Element[]>([]);
  const [componentsToShowGP, setComponentsToShowGP] = useState<JSX.Element[]>(
    [],
  );

  const [assessmentData, setAssessmentData] = useState<AssessmentData | null>(
    null,
  );
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState<any>(null);

  const [gradedPopQuizData, setGradedPopQuizData] =
    useState<GradedPopQuizResponse | null>(null);

  const overallAvgScore =
    gradedPopQuizData?.graded_popquiz_data &&
      gradedPopQuizData.graded_popquiz_data.length > 0
      ? Math.round(
        gradedPopQuizData.graded_popquiz_data.reduce(
          (sum: number, item: GradedPopQuizItem) =>
            sum + (item.pop_quiz_avg || 0),
          0,
        ) / gradedPopQuizData.graded_popquiz_data.length,
      )
      : 0;

  const getScroeBoardResult = (
    score: number,
  ): {
    backgroundColor: string;
    textColor: string;
    bulbImage: string;
    text: string;
  } => {
    let backgroundColor: string;
    let textColor: string;
    let bulbImage: string;
    let text: string;
    if (score === 0) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = ZeroBulb;
      text =
        "Let’s get started! 🚀\nBegin with the first topic and take it one step at a time.";
    } else if (score >= 1 && score <= 10) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Let’s refocus! 📘✨ \nSpend a little more time reviewing the basics.";
    } else if (score >= 11 && score <= 20) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Keep trying! 💪📚 \nIdentify where you’re stuck and revise those topics.";
    } else if (score >= 21 && score <= 30) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Stay consistent! 🔍✨ \nPractice regularly and try solving a few sample questions.";
    } else if (score >= 31 && score <= 40) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Good effort, but needs more focus! 🎯📘 \nRevise the key concepts daily.";
    } else if (score >= 41 && score <= 50) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = RedBulb;
      text =
        "Nice attempt! 📈 \nRevisit difficult areas—you’re closer than you think!";
    } else if (score >= 51 && score < 60) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "Great job! 🚀✨\nKeep the momentum going by practicing a bit more each day.";
    } else if (score >= 60 && score <= 70) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "Fantastic progress! 🔥✨\nA little more consistency will take you even higher!";
    } else if (score >= 71 && score < 80) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "You’re doing great! 🎉 \nBrush up on weak areas to boost your score further.";
    } else {
      backgroundColor = "#CBFAE9";
      text = "Congratulations! You did it 🎉 Keep shining!";
      textColor = "#24C782";
      bulbImage = GreenBulb;
    }

    return {
      backgroundColor,
      textColor,
      bulbImage,
      text,
    };
  };
  const [slidebarOptions, setSlidebarOptions] = useState<string[]>([]);
  const [programsFilters, setPrograms] = useState<AssessmentItem[]>([]);
  const { activeTab, selectedItem, selectedCandidateId, selectedAssessmentId } =
    useSelector((state: RootState) => state.advancedFilter);
  const { getProgramList, getSubjectList, getTopicsList, getVideosList } =
    VideoExportApiCallServices();
  const [filterFieldsList, setFilterFieldsList] = useState<FilterFieldNested[]>(
    [],
  );
  const { gradedProgram, subjects, selectedProgram, selectedSubject } =
    useSelector((state: RootState) => state.advancedFilterGradedPopQuiz);
  const [showNotification, setShowNotification] = useState<boolean>(false);

  const notifications = {
    today: [
      {
        id: 1,
        title: "Your score for 'Module 3: UI Principles Quiz' is now available",
        linkText: "View Results",
        time: "31 March 2023 - 09.02 AM",
      },
      {
        id: 2,
        title:
          "Instructor Sarah left a comment on your 'Python Basics Assessment'.",
        linkText: "Click to View",
        time: "31 March 2023 - 09.02 AM",
      },
    ],
    yesterday: [
      {
        id: 3,
        title: "Your score for 'Module 3: UI Principles Quiz' is now available",
        linkText: "View Results",
        time: "31 March 2023 - 09.02 AM",
      },
      {
        id: 4,
        title:
          "Instructor Sarah left a comment on your 'Python Basics Assessment'.",
        linkText: "Click to View",
        time: "31 March 2023 - 09.02 AM",
      },
      {
        id: 5,
        title: "Your score for 'Module 3: UI Principles Quiz' is now available",
        linkText: "View Results",
        time: "31 March 2023 - 09.02 AM",
      },
      {
        id: 6,
        title:
          "Instructor Sarah left a comment on your 'Python Basics Assessment'.",
        linkText: "Click to View",
        time: "31 March 2023 - 09.02 AM",
      },
      {
        id: 7,
        title: "Your score for 'Module 3: UI Principles Quiz' is now available",
        linkText: "View Results",
        time: "31 March 2023 - 09.02 AM",
      },
      {
        id: 8,
        title:
          "Instructor Sarah left a comment on your 'Python Basics Assessment'.",
        linkText: "Click to View",
        time: "31 March 2023 - 09.02 AM",
      },
    ],
  };
  // Check if concept data exists
  const hasConceptData =
    (assessmentData?.domain_scores?.some(
      (item) => (item.concept_scores?.length ?? 0) > 0,
    ) &&
      state.title === "Curriculum Performance") ||
    (assessmentData?.domain_scores?.some(
      (item) => (item.concept_scores?.length ?? 0) > 0,
    ) &&
      state.title === "Program Performance");

  useEffect(() => {
    if (programsFilters.length > 0) {
      const first = programsFilters[0];
      dispatch(setSelectedItem(first));
      // setSelectedCandidateId(first.candidate_id);
      // setSelectedAssessmentId(first.assessment_id);

      // Optional: trigger API on auto-select
      // onView(first.candidate_id, first.assessment_id);
    }
  }, [programsFilters]);
  //  useEffect(() => {
  //   if(selectedToggle==="Graded pop-quiz")
  //     fetchPrograms();
  //   }, []);
  const resetTriggeredRef = useRef(false);

  useEffect(() => {
    if (!resetGP) return;

    Logger.info("Reset GP triggered");

    resetTriggeredRef.current = true; // 🔐 allow next effect once
    fetchPrograms(); // async
  }, [resetGP]);
  // useEffect(() => {
  //   // block normal program selection
  //   if (!resetTriggeredRef.current) return;

  //   // wait until program is ready
  //   if (!selectedProgram?.program_id) return;

  //   Logger.info("Calling handleGPView after reset only");

  //   handleGPView(selectedProgram.program_id, subjects);

  //   //  close the gate (VERY IMPORTANT)
  //   resetTriggeredRef.current = false;
  // }, [selectedProgram?.program_id]);

  // Default trigger after fetching programs & subjects
  // useEffect(() => {
  //   if (
  //     selectedProgram &&
  //     subjects.length > 0 &&
  //     selectedToggle === "Pop-Quiz"
  //   ) {
  //     handleGPView(selectedProgram.program_id, subjects);
  //   }
  // }, [selectedToggle, resetGP]);
  const handleGPView = (program_id: string, subjectList: any[]) => {
    Logger.info("Parent calling API with:", program_id, subjectList);
    fetchGradedPopQuiz(program_id, true, subjectList);
    //  Call your main API here
  };
  const isInitialLoadRef = useRef(true);

  useEffect(() => {
    if (selectedToggle === "Pop-Quiz") {
      // Only fetch on initial load if it's the first time
      if (isInitialLoadRef.current) {
        Logger.info("Initial fetch for graded pop quiz");
        fetchGradedPopQuiz("", true, [], undefined, true);
        isInitialLoadRef.current = false;
      }
    }
    dispatch(setSelectedProgram(null));
  }, [selectedToggle, resetGP]);
  const fetchAssessmentsApi = async (
    domain: string,
  ): Promise<AssessmentItem[]> => {
    const param = {
      offset_time: CommonUtils.formatLocalTime(),
      domain_name: domain,
    };

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    const response = await api.get<AssessmentResponse>(
      assesClient.assesUrl,
      param,
    );

    return response.data.assessment_names || [];
  };
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  //  useEffect(() => {
  //   if(selectedToggle==="Graded pop-quiz")
  //   //Program APi
  //   getProgramList({
  //     onCallBack: (data: ProgramList[]) => {
  //       const programFilterList: FilterGroup[] = data.map(
  //         (item: ProgramList) => ({
  //           label: item.program_title,
  //           data: item,
  //           selected: false,
  //         })
  //       );

  //       setFilterFieldsList([
  //         {
  //           fieldLabel: "Program Name",
  //           fieldName: "program",
  //           options: programFilterList,
  //           isSingleSelect: true,
  //         },
  //       ]);
  //     },
  //   });
  // }, [selectedToggle]);
  // Update sidebar when data changes
  useEffect(() => {
    const options = [
      "Overall Results",
      ...(hasConceptData ? ["View Concept Analytics"] : []),
    ];

    setSlidebarOptions(options);

    // If concept analytics tab is removed due to no data → reset selected tab
    if (!hasConceptData && selectedSlideBarRes === "View Concept Analytics") {
      setSelectedSlideBarRes("Overall Results");
    }
  }, [assessmentData, hasConceptData]);

  // 🔹 Fetch programs & industries on mount
  useEffect(() => {
    const loadData = async () => {
      const programList = await fetchAssessmentsApi(
        profileData.partner_institute === true ? "Program" : "Industry",
      );
      setPrograms(programList);

      setActiveTab(
        profileData.partner_institute === true ? "program" : "industry",
      );

      // Call default view with first program
      if (programList.length > 0) {
        Logger.info("program list", programList);
        const first = programList[0];
        handleView(first.candidate_id, first.assessment_id);
      }
    };
    if (state.title === "Program Performance") loadData();
    if (state.assessmentId) {
      fetchAssessmentsApi(
        state.assessmentType === "JOZUNA"
          ? "jozuna"
          : state.assessmentType === "Curriculum"
            ? "curriculum"
            : state.assessment_type === "Industry"
              ? "industry"
              : "",
      );
    }
  }, []);

  // 🔹 Handler for when child triggers "View"
  const handleView = (
    candidateId: string | null,
    assessmentId: string | null,
  ) => {
    Logger.info("Parent calling API with:", candidateId, assessmentId);
    fetchTabs(candidateId, assessmentId);
    // 👉 Call your main API here
  };

  useEffect(() => {
    if (
      state.title === "Jozuna Skills Performance" &&
      selectedToggle === "Assessments Results"
    ) {
      getJozunaCurriculumProgramViewDetailDataAPI("Jozuna");
    } else if (
      state.title === "Curriculum Performance" &&
      selectedSlideBar === "Overall Progress"
    ) {
      getJozunaCurriculumProgramViewDetailDataAPI("Curriculum");
    } else if (
      state.title === "Program Performance" &&
      selectedSlideBar === "Overall Progress"
    ) {
      // getJozunaCurriculumProgramViewDetailDataAPI("Industry");
    }
  }, []);

  // useEffect(() => {
  //   const jozSkill = state.title;
  //   dispatch(
  //     setSelectedToggle(
  //       jozSkill === "Jozuna Skills Performance" ||
  //         jozSkill === "Curriculum Performance"
  //         ? "Assessments Results"
  //         : "Pop-Quiz"
  //     )
  //   );
  // }, []);
  // useEffect(() => {
  //   //Handling of the  Navigation Back of State from Asssement Reuslt
  //   if (
  //     selectedToggle === "Assessments Results" &&
  //     state.title === "Program Performance" &&
  //     selectedItem
  //   ) {
  //     handleView(selectedItem.candidate_id, selectedItem.assessment_id);
  //   }
  // }, []);
  useEffect(() => {
    if (state.assessmentId && state.title === "Program Performance") {
      fetchTabs(null, state.assessmentId);
    }
  }, [state.assessmentId, state.title]);
  if (!state) {
    return <div>No data available</div>;
  }
  const dummyProgramPerformanceData = {
    curriculum_professional_assessment: [
      {
        category_id: "5e1a8795-0da6-4b83-a611-dc317e006cd3",
        category_name: "Concept inventory question 2",
        professional_score: 37.5,
        actual_professional_marks: 3.0,
        questions: [
          { question_id: "1", question: "Question A", is_correct: false },
          { question_id: "2", question: "Question B", is_correct: true },
          { question_id: "3", question: "Question C", is_correct: false },
          { question_id: "4", question: "Question D", is_correct: true },
        ],
        concept_scores: [
          { concept_name: "Biology", concept_score: "100%" },
          { concept_name: "Physics", concept_score: "100%" },
          { concept_name: "Chemistry", concept_score: "100%" },
          { concept_name: "Maths", concept_score: "0%" },
        ],
      },
    ],
  };
  // const fetchTabs = async (
  //   candidateId: string | null,
  //   assessmentId: string | null
  // ) => {
  //   const param = { candidate_id: candidateId, assessment_id: assessmentId };
  //   api.setAuthToken(LocalStorage.getLocalData("access_token"));
  //   Loader.showLoading("Loading...");
  //   setComponentsToShow([]);
  //   try {
  //     if (state.title === "Jozuna Skills Performance") {
  //       const response = await api.get<AssessmentData>(
  //         StudentDashBoardClient.assessment_score,
  //         param
  //       );

  //       if (response.data) {
  //         const components: JSX.Element[] = [];
  //         setAssessmentData(response.data);
  //         // setAssessmentData(dummyProgramPerformanceData as any);
  //         if (
  //           response.data.skill_report?.length > 0 &&
  //           state.title === "Jozuna Skills Performance"
  //         ) {
  //           components.push(<SkillScorePage data={response.data!} />);
  //         }
  //         setComponentsToShow(components);
  //       } else {
  //         setComponentsToShow([]);
  //       }
  //     } else {
  //       const response = await api.get<AssessmentData>(
  //         `${
  //           StudentDashBoardClient.assessment_candidate_score
  //         }?assessment_id=${assessmentId}&domain_type=${
  //           state.title === "Curriculum Performance" ? "Curriculum" : "Program"
  //         }`
  //       );
  //       if (response.data) {
  //         const components: JSX.Element[] = [];

  //         if (state.title === "Curriculum Performance") {
  //           components.push(
  //             <OverallResultCardPage
  //               data={response.data.domain_scores ?? []}
  //               date={response.data.submitted_date ?? ""}
  //               assessment_title={response.data.assessment_name}
  //               overall_score={response.data.overall_score ?? 0}
  //               duration={response.data.duration}
  //               onViewResultClick={() => navigate("result_overview")}
  //             />
  //           );
  //         }

  //         if (state.title === "Program Performance") {
  //           components.push(
  //             <OverallResultCardPage
  //               data={response.data.domain_scores ?? []}
  //               date={response.data.submitted_date ?? ""}
  //               assessment_title={response.data.assessment_name}
  //               overall_score={response.data.overall_score ?? 0}
  //               duration={response.data.duration}
  //               onViewResultClick={() => navigate("result_overview")}
  //             />
  //           );
  //         }

  //         setComponentsToShow(components);
  //       } else {
  //         setComponentsToShow([]);
  //       }
  //     }
  //   } catch (error) {
  //   } finally {
  //     Loader.dismissLoading();
  //   }
  // };

  const fetchTabs = async (
    candidateId: string | null,
    assessmentId: string | null,
  ) => {
    const param = {
      candidate_id: candidateId,
      assessment_id: state.assessmentId ? state.assessmentId : assessmentId,
    };
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Loader.showLoading("Loading...");
    setComponentsToShow([]);
    try {
      if (state.title === "Jozuna Skills Performance") {
        const response = await api.get<AssessmentData>(
          StudentDashBoardClient.assessment_score,
          param,
        );

        if (response.data) {
          const components: JSX.Element[] = [];
          setAssessmentData(response.data);
          if (
            response.data.skill_report?.length > 0 &&
            state.title === "Jozuna Skills Performance"
          ) {
            components.push(<SkillScorePage data={response.data!} />);
          }
          setComponentsToShow(components);
        } else {
          setComponentsToShow([]);
        }
      } else {
        const response = await api.get<AssessmentData>(
          `${StudentDashBoardClient.assessment_candidate_score
          }?assessment_id=${state.assessmentId ? state.assessmentId : assessmentId}&domain_type=${state.title === "Curriculum Performance" ? "Curriculum" : "Program"
          }`,
        );
        if (response.data) {
          setAssessmentData(response.data);
          const components: JSX.Element[] = [];

          if (state.title === "Curriculum Performance") {
            components.push(
              <OverallResultCardPage
                data={response.data.domain_scores ?? []}
                date={response.data.submitted_date ?? ""}
                assessment_title={response.data.assessment_name}
                overall_score={response.data.overall_score ?? 0}
                duration={response.data.duration}
                showAnswers={response.data.show_answers} // added for show and hide the Viee Result button for curriculum
                curriculum={"Yes"}
                onViewResultClick={(record) =>
                  navigate("result_overview", {
                    state: {
                      ...state, // ✅ preserve Page A state
                      data: response.data,
                      domain_data: record,
                      performance: "Curriculum",
                      assessmentId: assessmentId,
                    },
                  })
                }
              />,
            );
          }

          if (state.title === "Program Performance") {
            components.push(
              <OverallResultCardPage
                data={response.data.domain_scores ?? []}
                date={response.data.submitted_date ?? ""}
                assessment_title={response.data.assessment_name}
                overall_score={response.data.overall_score ?? 0}
                duration={response.data.duration}
                curriculum={"No"}
                onViewResultClick={(record) =>
                  navigate("result_overview", {
                    state: {
                      data: response.data,
                      domain_data: record,
                      performance: "Program",
                    },
                  })
                }
              />,
            );
          }

          setComponentsToShow(components);
        } else {
          setComponentsToShow([]);
        }
      }
    } catch (error) {
      // Handle error if needed
      console.error("Error in fetchTabs:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const getJozunaCurriculumProgramViewDetailDataAPI = async (
    domain_type: string,
  ) => {
    Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<OverviewDataResponse>(
        "/candidate/overview",
        { domain_type },
      );

      if (state.title === "Jozuna Skills Performance") {
        const colorPalette = [
          "#ffa300",
          "#468ff8",
          "#9eb82b",
          "#07A79d",
          "#ff6f61",
          "#6a4c93",
        ];
        // const getBackgroundColor = (progress: number | null, score: number) => {
        //   // If progress is null, use score logic
        //   if (progress === null) {
        //     if (score >= 80) return "#e3fff5"; // green
        //     if (score >= 50) return "#fff8d8"; // yellow
        //     return "#ffeeee"; // red
        //   }

        //   // If progress is not null, use progress logic
        //   if (progress === 1) return "#e3fff5"; // green
        //   if (progress === 0) return "#fff8d8"; // yellow

        //   // fallback (if some other unexpected value comes)
        //   return "#ffeeee"; // red
        // };

        // Build chart configs per domain
        const chartConfigs = response.data.overview_data.map((domain) => {
          // 1️⃣ Collect all unique skill names for this domain
          const allSkillNames = Array.from(
            new Set(
              domain.assessment_score_list.flatMap((assess) =>
                assess.jozuna_skill_data.map((skill) => skill.skill_name),
              ),
            ),
          );
          const getBackgroundColor = (
            progress: number | null,
            score: number,
          ) => {
            // If progress is null, use score logic
            if (score === null) {
              return "#E2EFFF"; // red
            }

            // If progress is not null, use progress logic
            if (score >= 80) return "#e3fff5"; // green
            if (score >= 50 && score <= 79.99) return "#fff8d8"; // yellow

            // fallback (if some other unexpected value comes)
            return "#ffeeee"; // red
          };

          const bgColor = getBackgroundColor(domain.progress, domain.score);

          // 2️⃣ Build `data` array for the chart (X-axis: assessment_name)
          const data = domain.assessment_score_list.map((assessment) => {
            const row: Record<string, any> = {
              stage: assessment.assessment_name,
              dateTime: assessment.assessment_date_time,
            };
            allSkillNames.forEach((skillName) => {
              const foundSkill = assessment.jozuna_skill_data.find(
                (s) => s.skill_name === skillName,
              );
              row[skillName] = foundSkill ? foundSkill.score : 0;
            });
            return row;
          });

          // 3️⃣ Build `skills` array for legend/colors
          const skills = allSkillNames.map((skillName, index) => ({
            gridColor: CommonUtils.getGridColor(domain.progress),
            bgColor,
            key: skillName,
            label: skillName,
            color: colorPalette[index % colorPalette.length],
          }));

          return {
            bgColor,
            title: domain.domain_name,
            data,
            skills,
          };
        });

        setChartConfigs(chartConfigs); // send to chart
      } else if (
        state.title === "Curriculum Performance" ||
        state.title === "Program Performance"
      ) {
        // const getBackgroundColor = (progress: number | null, score: number) => {
        //   // If progress is null, use score logic
        //   if (progress === null) {
        //     return "#E2EFFF"; // red
        //   }

        //   // If progress is not null, use progress logic
        //   if (progress === 1) return "#e3fff5"; // green
        //   if (progress === 0) return "#fff8d8"; // yellow

        //   // fallback (if some other unexpected value comes)
        //   return "#ffeeee"; // red
        // };
        const getBackgroundColor = (progress: number | null, score: number) => {
          // If progress is null, use score logic
          if (score === null) {
            return "#E2EFFF"; // red
          }

          // If progress is not null, use progress logic
          if (score >= 80) return "#e3fff5"; // green
          if (score >= 50 && score <= 79.99) return "#fff8d8"; // yellow

          // fallback (if some other unexpected value comes)
          return "#ffeeee"; // red
        };

        const getlineColor = (progress: number | null, score: number) => {
          // const valueToUse = progress === null ? score : progress;
          const valueToUse = score;
          // if (progress === null) {
          if (valueToUse >= 80) return "#24c782"; // green
          if (valueToUse >= 50 && valueToUse <= 79.99) return "#ffca64"; // orange
          return "#e84c3d"; // red
          // }
          // if (progress === 1) return "#24c782"; // green
          // if (progress === 0) return "#ffca64"; // yellow

          // // fallback (if some other unexpected value comes)
          // return "#e84c3d"; // red}
        };
        const curriculumData = response.data.overview_data.map((domain) => {
          const bgColor = getBackgroundColor(domain.progress, domain.score);
          const lineColor = getlineColor(domain.progress, domain.score);

          return {
            gridColor: CommonUtils.getGridColor(domain.progress),
            title: domain.domain_name,
            bgColor, // 👈 pass background color
            data: domain.assessment_score_list.map((a) => ({
              stage: a.assessment_name, // X-axis
              dateTime: a.assessment_date_time,
              score: a.score, // Y-axis
            })),
            skills: [
              {
                key: "score",
                label: "Score",
                color: lineColor,
              },
            ],
          };
        });

        setChartConfigs(curriculumData);
      }
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const getCurriculumProgramViewDetailCPDataAPI = async (
    domain_type: string,
  ) => {
    Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<ConceptScoreDataResponse>(
        "/candidate/concept_overview",
        { domain_type },
      );

      // if (state.title === "Jozuna Skills Performance") {
      const colorPalette = [
        "#ffa300",
        "#468ff8",
        "#9eb82b",
        "#07A79d",
        "#ff6f61",
        "#6a4c93",
      ];
      // const getBackgroundColor = (progress: number | null, score: number) => {
      //   // If progress is null, use score logic
      //   if (progress === null) {
      //     if (score >= 80) return "#e3fff5"; // green
      //     if (score >= 50) return "#fff8d8"; // yellow
      //     return "#ffeeee"; // red
      //   }

      //   // If progress is not null, use progress logic
      //   if (progress === 1) return "#e3fff5"; // green
      //   if (progress === 0) return "#fff8d8"; // yellow

      //   // fallback (if some other unexpected value comes)
      //   return "#ffeeee"; // red
      // };

      // Build chart configs per domain
      const chartConfigs = response.data.concept_score_data.map((domain) => {
        // 1️⃣ Collect all unique skill names for this domain
        // const getBackgroundColor = (progress: number | null, score: number) => {
        //   // If progress is null, use score logic
        //   if (progress === null) {
        //     return "#E2EFFF"; // red
        //   }

        //   // If progress is not null, use progress logic
        //   if (progress === 1) return "#e3fff5"; // green
        //   if (progress === 0) return "#fff8d8"; // yellow

        //   // fallback (if some other unexpected value comes)
        //   return "#ffeeee"; // red
        // };
        const getBackgroundColor = (progress: number | null, score: number) => {
          // If progress is null, use score logic
          if (score === null) {
            return "#E2EFFF"; // red
          }

          // If progress is not null, use progress logic
          if (score >= 80) return "#e3fff5"; // green
          if (score >= 50 && score <= 79.99) return "#fff8d8"; // yellow

          // fallback (if some other unexpected value comes)
          return "#ffeeee"; // red
        };

        const bgColor = getBackgroundColor(domain.progress, domain.score);

        // 2️⃣ Build `data` array for the chart (X-axis: assessment_name)
        const allSkillNames = Array.from(
          new Set(
            domain.concept_score_list.flatMap((assess) =>
              assess.concept_scores.map((skill) => skill.concept_name),
            ),
          ),
        );

        const data = domain.concept_score_list.map((assessment) => {
          const row: Record<string, any> = {
            stage: assessment.assessment_name,
            dateTime: assessment.assessment_date_time,
          };
          allSkillNames.forEach((skillName) => {
            const foundSkill = assessment.concept_scores.find(
              (s) => s.concept_name === skillName,
            );
            row[skillName] = foundSkill
              ? parseInt(foundSkill.concept_score.replace("%", ""), 10)
              : 0;
          });
          return row;
        });

        // 3️⃣ Build `skills` array for legend/colors
        const skills = allSkillNames.map((skillName, index) => ({
          gridColor: CommonUtils.getGridColor(domain.progress),

          bgColor,
          key: skillName,
          label: skillName,
          color: colorPalette[index % colorPalette.length],
        }));

        return {
          bgColor,
          title: domain.domain_name,
          data,
          skills,
        };
      });

      setChartCPConfigs(chartConfigs); // send to chart
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  const handleOnAssessmentChange = (value: AssessmentDetails | null) => {
    if (value) {
      state.assessmentId = null;
      fetchTabs(value.candidate_id, value.assessment_id);

      setSelectedAssessmentId(value.assessment_entity_id || "");
    }

    Logger.info("Selected Assessment ID:", value?.assessment_entity_id);
  };
  // const [selectedSlideBarRes, setSelectedSlideBarRes] = useState("Overall Results");

  const validAssessments = [
    ...(assessmentData?.domain_scores ?? []),
    //...(assessmentData?.domain_scores ?? []),
    ...(gradedPopQuizData?.graded_popquiz_data ?? []),
  ].filter((item) => (item.concept_scores?.length ?? 0) > 0);

  const isSingleCard = validAssessments.length === 1;

  const hasEnoughConcepts =
    isSingleCard && (validAssessments[0].concept_scores?.length ?? 0) > 2;

  const shouldUseFullWidth = isSingleCard && hasEnoughConcepts;
  const validAssessmentsProPerf = [
    ...(assessmentData?.domain_scores ?? []),
    ...(gradedPopQuizData?.graded_popquiz_data ?? []),
    // ...(assessmentData?.domain_scores ?? []),
  ].filter((item) => (item.concept_scores?.length ?? 0) > 0);

  const isSingleCardProPerf = validAssessmentsProPerf.length === 1;

  const hasEnoughConceptsProPerf =
    isSingleCard &&
    (validAssessmentsProPerf[0].concept_scores?.length ?? 0) > 2;

  const shouldUseFullWidthProPerf =
    isSingleCardProPerf && hasEnoughConceptsProPerf;

  // 🔹 Fetch Programs
  const setAuthToken = () => {
    api.setAuthToken(localStorage.getItem("access_token") || "");
  };
  const fetchPrograms = async () => {
    Loader.showLoading();
    setAuthToken();

    try {
      const res = await api.get<ProgramListResponse>(
        VideoReportClient.getProgramListGP,
      );

      const programs = res.data.programs; // 🔥 FIX HERE

      Logger.info("Program Data:", programs);

      if (programs && programs.length > 0) {
        dispatch(setgradedProgram(programs));

        const firstProgram = programs[0];
        // dispatch(setSelectedProgram(firstProgram));

        // Logger.info("First Program Selected:", firstProgram);

        // fetchSubjects(firstProgram.program_id);
      }
    } catch (e) {
      showAlert({
        identity: "default",
        show: true,
        title: "Error",
        message: "Failed to fetch programs",
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  // 🔹 Fetch Subjects by Program
  const fetchSubjects = async (programId: string) => {
    Loader.showLoading();
    setAuthToken();
    try {
      const params: videolandingPageRequest = {
        program_category: "Industry",
        program_id: programId,
      };

      const res = await api.get<SubjectResponse>(
        VideoReportClient.getSubjectsList,
        params,
      );
      const list: SubjectList[] = res.data?.list_courses || [];
      // dispatch(setSubjects(list));

      const mapped: SubjectOption[] = [
        { label: "Select All", data: "ALL", selected: true },
        ...list.map((s) => ({
          label: s.course_title,
          data: s,
          selected: true,
        })),
      ];

      dispatch(setSubjects(mapped));
      dispatch(setSelectedSubject(null));
    } catch (e) {
      showAlert({
        identity: "default",
        show: true,
        title: "Error",
        message: "Failed to fetch subjects",
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  interface SubjectOption {
    label: string;
    data: SubjectList | "ALL";
    selected: boolean;
  }
  const fetchGradedPopQuiz = async (
    programId?: string,
    selectedStatus?: boolean,
    subjectList?: SubjectOption[],
    course_id?: string,
    isInitialLoad: boolean = false,
  ) => {
    // if (!programId) return;

    Loader.showLoading();
    setAuthToken();
    setComponentsToShowGP([]);

    try {
      // Determine Select All
      const params: any = {};

      if (!isInitialLoad) {
        const selectAll =
          subjectList?.length === 0 || subjectList?.every((s) => s.selected);

        params.program_id = programId;
        params.select_all = resetGP === true ? "true" : selectAll;

        const selectedCourseIds = subjectList
          ?.filter((s) => s.selected && s.data !== "ALL")
          .map((s) => (s.data as SubjectList).course_id);

        if (course_id) {
          params.course_id = course_id;
        } else if (!selectAll && selectedCourseIds?.length) {
          params.course_id = selectedCourseIds.join(",");
        }
      }

      const res = await api.get<GradedPopQuizResponse>(
        "/candidate/graded_pop_quiz",
        params,
      );
      const components: JSX.Element[] = [];
      setGradedPopQuizData(res.data);
      setresetGP(false);

      if (
        !res.data?.graded_popquiz_data ||
        res.data.graded_popquiz_data.length === 0
      ) {
        // dispatch(setSelectedToggle("Assessments Results"));
        // setresetGP(true);
        // getJozunaCurriculumProgramViewDetailDataAPI("Industry");
        // return;
      }

      if (
        // response.data.curriculum_professional_assessment?.length > 0 &&
        state.title === "Curriculum Performance" ||
        state.title === "Program Performance"
      ) {
        components.push(
          <GradedPopQuizCardPage
            data={res.data}
            // date={response.data.timestamp}
            // assessment_title={res.data.graded_popquiz_data.}
            // overall_score={response.data.curriculum_assessment_score}
            // duration={response.data.duration}
            onViewResultClick={(quiz: any) => {
              setSelectedQuiz(quiz);
              setShowOverlay(true);
            }}
          />,
        );
      }
      setComponentsToShowGP(components);
    } catch (e) {
      showAlert({
        identity: "default",
        show: true,
        title: strings.error_msg.something_wrg,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  //  Default trigger after fetching programs & subjects
  const isSelectAllFromSubjects = (subjects: any[]) => {
    if (!subjects || subjects.length === 0) return true;
    return subjects.slice(1).every((s) => s.selected);
  };

  const getSelectedCourseIdFromSubjects = (subjects: any[]) => {
    const selected = subjects.find((s) => s.selected && s.data !== "ALL");

    if (!selected || selected.data === "ALL") return null;
    return selected.data.course_id;
  };

  const handleExportPopQuiz = async (
    programId: string,
    subjects: any[],
    fileType: string,
  ) => {
    Loader.showLoading();
    setAuthToken();

    try {
      const selectAll = isSelectAllFromSubjects(subjects);
      const courseId = getSelectedCourseIdFromSubjects(subjects);

      const params: any = {
        program_id: programId,
        file_type: fileType,
      };
      if (!selectAll && courseId) {
        params.course_id = courseId;
      }
      Logger.info("Export Pop Quiz Params:", params);

      const res = await api.post<AssessmentExportResponse>(
        "/export/pop_quiz",
        {},
        { params },
      );

      // ✅ download file
      if (res.data.file_path) {
        window.open(res.data.file_path, "_blank");
        // setShowNotification("File exported successfully!");
        showAlert({
          identity: "default",
          show: true,
          title: "Success",
          message: "File exported successfully",
          button1Text: "Ok",
          alertType: "success",
          onlyNeedOneButton: true,
        });
      }
      if (res.data.detail) {
        window.open(res.data.file_path, "_blank");
        // setShowNotification("File exported successfully!");
        showAlert({
          identity: "default",
          show: true,
          title: "Success",
          message: res.data.detail,
          button1Text: "Ok",
          alertType: "success",
          onlyNeedOneButton: true,
        });
      }
    } catch (e) {
      showAlert({
        identity: "default",
        show: true,
        title: "Error",
        message: "Failed to export pop quiz",
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
      });
    } finally {
      Loader.dismissLoading();
    }
  };

  return (
    <div className="v2-dashboard-container">
      <div className="v2-dashboard-header">
        <div
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
            boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)",
            height: "12vh",
            // flexGrow: 1,
            // padding: "12px",
            // paddingRight: "25px",
            // height: "50px",./
            zIndex: 10000,
          }}
        >
          <div
            style={{
              padding: "20px",
              paddingBottom: "10px",
              paddingTop: "20px",

              color: "#000000",
              // marginLeft: "20px",
              fontWeight: "600",
              fontFamily: "Mazzard",
              fontSize: "16px",
              // marginRight: "20px", // Adjust margin to provide space after the welcome message
            }}
          >
            {profileData.first_name} {profileData.last_name}'s Growth Dashboard
            <div
              style={{
                color: "#000000",
                //   marginLeft: "20px",
                fontWeight: "300",
                fontFamily: "Mazzard",
                fontSize: "14px",
                //   marginRight: "20px", // Adjust margin to provide space after the welcome message
              }}
            >
              Let's make today count. Here is your learning progress.
            </div>
          </div>

          <div
            style={{
              padding: "20px",
              paddingBottom: "0px",
              paddingTop: "20px",

              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#FFDCD1",
                borderRadius: "30px",
                padding: "10px",
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <img
                src={motivationIcon}
                alt=""
                style={{ height: "20px", width: "20px" }}
              />
              <span style={{ fontFamily: "AutourOne", fontSize: "14px" }}>
                {" "}
                Consistency beats intensity. Show up every day
              </span>
              <img
                src={cancelIcon}
                alt=""
                style={{ height: "20px", width: "20px" }}
              />
            </div>
            <img
              src={notificationIcon}
              alt=""
              onClick={() => {
                setShowNotification(true);
              }}
              style={{
                height: "40px",
                width: "40px",
                cursor: "pointer",
                position: "relative", //  IMPORTANT
              }}
            />
            {showNotification && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                  zIndex: 9998,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                  paddingTop: "25px",
                  paddingRight: "40px",
                }}
              >
                <div
                  style={{
                    width: "500px",
                    backgroundColor: "#ffffff",
                    borderRadius: "20px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                    zIndex: 9999,
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "500px",
                  }}
                >
                  {/* Header */}
                  <div style={{ padding: "20px 20px 0 20px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "4px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <img
                          src={notificationIcon}
                          alt=""
                          style={{ width: "40px", height: "40px" }}
                        />
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          Notifications
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#6c757d",
                            }}
                          >
                            Stay update with your last notification
                          </div>
                        </div>
                      </div>
                      <img
                        onClick={() => setShowNotification(false)}
                        alt=""
                        src={notifyCancel}
                        style={{
                          cursor: "pointer",

                          width: "28px",
                          height: "28px",
                        }}
                      />
                    </div>
                    <hr
                      style={{
                        border: "0.5px solid #eee",
                        margin: "12px 0 0 0",
                      }}
                    />
                  </div>

                  {/* Scrollable Content */}
                  <div
                    style={{
                      flex: 1,
                      overflowY: "auto",
                      padding: "0 20px 20px 20px",
                      marginTop: "8px",
                    }}
                  >
                    {/* Today Section */}
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#6c757d",
                        marginBottom: "12px",
                      }}
                    >
                      Today
                    </div>
                    {notifications.today.map((notif) => (
                      <div
                        key={notif.id}
                        style={{
                          marginBottom: "20px",
                          display: "flex",
                          gap: "12px",
                        }}
                      >
                        {/* Blue vertical indicator */}
                        <div
                          style={{
                            width: "3px",
                            backgroundColor: "#3366FF3D",
                            borderRadius: "2px",
                            flexShrink: 0,
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#212529",
                            }}
                          >
                            {notif.title}{" "}
                            <span
                              style={{
                                color: "#4A90E2",
                                cursor: "pointer",
                                fontWeight: 500,
                                textDecoration: "underline",
                              }}
                            >
                              {notif.linkText}
                            </span>
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#adb5bd",
                              marginTop: "4px",
                            }}
                          >
                            {notif.time}
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Yesterday Section */}
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#6c757d",
                        marginBottom: "12px",
                        marginTop: "8px",
                      }}
                    >
                      Yesterday
                    </div>
                    {notifications.yesterday.map((notif) => (
                      <div
                        key={notif.id}
                        style={{
                          marginBottom: "20px",
                          display: "flex",
                          gap: "12px",
                        }}
                      >
                        {/* Blue vertical indicator */}
                        {/* <div
                                    style={{
                                      width: "3px",
                                      backgroundColor: "#4A90E2",
                                      borderRadius: "2px",
                                      flexShrink: 0,
                                    }}
                                  /> */}
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#212529",
                            }}
                          >
                            {notif.title}{" "}
                            <span
                              style={{
                                color: "#4A90E2",
                                cursor: "pointer",
                                fontWeight: 500,
                                textDecoration: "underline",
                              }}
                            >
                              {notif.linkText}
                            </span>
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#adb5bd",
                              marginTop: "4px",
                            }}
                          >
                            {notif.time}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <img
              src={faqIcon}
              alt=""
              style={{ height: "40px", width: "40px" }}
            />
          </div>

          {/* UserDropdown component */}
          {/* <UserDropdown
                      userName={profileData.institute_name ?? ""}
                      onTabChange={handleTabChange}
                      onDropdownClick={() => setShowTabNavigator(true)}
                      partnerInstitute={profileData.partner_institute ?? false}
                    /> */}
        </div>
      </div>
      <div
        className="skillsHeader"
        style={{ paddingLeft: "20px", paddingRight: "20px" }}
      >
        <div className="skillsHeader-left">
          <img
            className="dashboardoverlayclose-btn"
            style={{ marginBottom: "8px" }}
            src={backArrow}
            alt="Back"
            onClick={() => {
              dispatch(setSelectedSubject(null));
              dispatch(setSelectedProgram(null));
              navigate("/dashboard/student");
              dispatch(setActiveTab("program"));
              dispatch(setSelectedToggle("Progress Timeline"));
            }}
          />
          <h2 className="skillsHeading">Detailed Insights - {state.heading}</h2>
          {state.title === "Jozuna Skills Performance" && (
            <div
              style={{ display: "flex", marginBottom: "5px" }}
              onClick={() => {
                navigate("/dashboard/recommendation/jozunaview", {
                  state: {
                    assessment_id: assessmentId,
                    title: "Jozuna Skill Recommendations",
                    heading: "Jozuna Skill Recommendations",
                  },
                });
              }}
              className="skillsSubtext"
            >
              <span>
                View Recommendations
                <img
                  src={BlueArrowImg}
                  alt="arrow"
                  className="skillsSubtextIcon"
                  style={{ marginRight: "10px", marginLeft: "6px" }}
                />
              </span>
            </div>
          )}
        </div>

        {state.toggleOptions && (
          <DashboardToggleComponent
            options={state.toggleOptions}
            value={selectedToggle} // Pass Redux state as controlled value
            onChange={(val) => {
              dispatch(setSelectedSubject(null));
              // dispatch(setSelectedProgram(null));

              setShowFilter(false);
              setSelectedSlideBar("Overall Progress");
              setSelectedSlideBarRes("Overall Results");
              dispatch(setSelectedToggle(val));
              if (val === "Assessments Results") {
                setresetGP(true);
                getJozunaCurriculumProgramViewDetailDataAPI("Industry");
                Logger.info("Toggle selected:", resetGP);
              }
              if (val === "Skills Timeline") {
                getJozunaCurriculumProgramViewDetailDataAPI("Jozuna");
                Logger.info("Toggle selected:", resetGP);
              }
              Logger.info("Toggle selected:", val);
              Logger.info("Toggle selected:", val);
            }}
          />
        )}
      </div>

      <div className="dashboard-divider"></div>
      <div
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingBottom: "20px",
        }}
      >
        {selectedToggle === "Progress Timeline" &&
          state.slidebarProgressOptions && (
            <div>
              <DashboardSlideBarComponent
                options={state.slidebarProgressOptions}
                onChange={(val) => {
                  setSelectedSlideBar(val);
                  if (selectedSlideBar === "Overall Progress") {
                    getCurriculumProgramViewDetailCPDataAPI(
                      state.title === "Curriculum Performance"
                        ? "Curriculum"
                        : "Industry",
                    );
                  }
                  Logger.info("Progress Timeline selected:", val);
                }}
              />{" "}
            </div>
          )}

        {(selectedToggle === "Assessments Results" ||
          selectedToggle === "Pop-Quiz") &&
          state.slidebarResultsOptions &&
          state.title != "Jozuna Skills Performance" && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // margin: "10px 25px",
                marginRight: "15px",
              }}
            >
              {selectedToggle === "Pop-Quiz" ? (
                <p
                  style={{
                    color: "#344054",
                    fontSize: "18px",
                    fontWeight: 600,
                    fontFamily: "Mazzard",
                    margin: 0,
                  }}
                >
                  Pop-Quiz Score
                </p>
              ) : (
                <DashboardSlideBarComponent
                  options={slidebarOptions}
                  onChange={(val) => {
                    setSelectedSlideBarRes(val);
                    Logger.info("Assessment Results selected:", val);
                  }}
                />
              )}
              {/* {selectedToggle === "Pop-Quiz" && (
  <div style={{ display: "flex", flexDirection: "column" }}>
    <p
      style={{
        color: "#344054",
        fontSize: "18px",
        fontWeight: 600,
        fontFamily: "Mazzard",
        margin: 0,
      }}
    >
      Overall Pop-Quiz Results
    </p>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        marginTop: "6px",
        color: "#344054",
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Mazzard",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <img src={VideoImg} alt="videos" />
<span>
  {gradedPopQuizData?.total_videos}{" "}
  {gradedPopQuizData?.total_videos === 1 ? "Video" : "Videos"}
</span>
      </div>

     
    </div>
  </div>
)} */}
              {(state.title === "Program Performance" && selectedToggle === "Pop-Quiz") ||
                (state.title === "Curriculum Performance" &&
                  selectedToggle === "Pop-Quiz") ? (
                <>
                  <div
                    style={{
                      gap: "10px",
                      position: "relative",
                      display: "flex", // important so popover aligns with button
                      alignItems: "center",
                    }}
                  >
                    <Button
                      variant="outline-primary"
                      style={{
                        backgroundColor: "#EBECED",
                        border: "none",
                        color: "#101828",
                        fontWeight: 400,
                        display: "flex",
                        height: "38px",
                        alignItems: "center",
                        gap: "8px", // space between items
                        // padding: "6px 12px",
                      }}
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      {/* Left icon */}
                      <img
                        src={filterIcon}
                        alt="filter"
                        style={{ width: "16px", height: "16px" }}
                      />

                      {/* Text */}
                      <span>Advanced Filter</span>

                      {/* Right icon */}
                      <img
                        src={downArrow}
                        alt="down arrow"
                        style={{ width: "10px", height: "10px" }}
                      />
                    </Button>

                    {showFilter && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: "0",
                          transform: "translateX(-63%)", // move left by its own width
                          marginTop: "6px",
                          zIndex: 9999,
                        }}
                      >
                        {/* {state.title === "Program Performance" &&
                          selectedToggle === "Assessments Results" && (
                            <AdvancedFilter
                              heading={state.title}
                              onReset={() => {
                                // setAssessmentData(null);
                                // setComponentsToShow([]);
                              }}
                              onView={(candidateId, assessmentId) => {
                                setShowFilter(false);
                                // call fetchTabs when user clicks View
                                fetchTabs(candidateId, assessmentId);
                              }}
                              selectedItems={selectedItem}
                              setSelectedItems={setSelectedItem}
                              isNotTimeStampNeed={true}
                            />
                          )} */}
                        {selectedToggle === "Pop-Quiz" && (
                          <SimpleProgramSubjectFilter
                            heading={state.title}
                            onReset={() => {
                              setShowFilter(false);
                            }}
                            setresetGP={setresetGP}
                            onView={(
                              program_id,
                              selectedStatus,
                              subjects,
                              course_id,
                            ) => {
                              setShowFilter(false);
                              // call fetchTabs when user clicks View
                              fetchGradedPopQuiz(
                                program_id || "",
                                selectedStatus || false,
                                subjects || [],
                                course_id || "",
                              );
                            }}
                            selectedItems={selectedItem}
                            setSelectedItems={setSelectedItem}
                          />
                        )}

                        {/* <AdvancedFilter
      programs={programsFilters}
      industries={industriesFilters}
      onReset={handleReset}
      onView={handleView}
    /> */}

                        {/* render dynamic components */}
                        {/* <div>{componentsToShow}</div> */}
                      </div>
                    )}
                    {selectedToggle === "Pop-Quiz" && (
                      <ExportComponent
                        onExport={(fileType: string) => {
                          if (
                            gradedPopQuizData?.graded_popquiz_data.length === 0
                          ) {
                            showAlert({
                              identity: "default",
                              show: true,
                              title: "Error",
                              message: "No data available to export",
                              button1Text: "Ok",
                              alertType: "error",
                              onlyNeedOneButton: true,
                            });
                            return;
                          } else {
                            handleExportPopQuiz(
                              selectedProgram?.program_id || "",
                              subjects,
                              fileType,
                            );
                          }
                        }}
                      ></ExportComponent>
                    )}
                    {selectedToggle === "Pop-Quiz" &&
                      gradedPopQuizData?.graded_popquiz_data &&
                      gradedPopQuizData.graded_popquiz_data.length > 0 && (
                        <div
                          className="industryresults-exam-feedback"
                          style={{
                            marginLeft: "15px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              color: "#344054",
                              fontSize: "15px",
                              fontWeight: 600,
                              fontFamily: "Mazzard",
                              marginRight: "6px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Overall Score:
                          </span>
                          <div
                            className="industryresults-exam-score"
                            style={{
                              backgroundColor:
                                getScroeBoardResult(overallAvgScore).backgroundColor,
                              marginRight: "0",
                            }}
                          >
                            <p
                              style={{
                                color: getScroeBoardResult(overallAvgScore).textColor,
                              }}
                            >
                              {overallAvgScore}%
                            </p>
                            <img
                              src={getScroeBoardResult(overallAvgScore).bulbImage}
                              className="industryresults-score-bulb"
                              alt="bulb"
                            />
                          </div>
                        </div>
                      )}
                  </div>
                </>
              ) : state.title !== "Program Performance" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: "25px",
                    marginTop: "10px",
                    marginBottom: "10px",
                    marginRight: "5px",
                    color: "#444444",
                    fontSize: "18px",
                    fontWeight: "500",
                  }}
                >
                  <span style={{ marginTop: "8px" }}>
                    Select your assessment:{" "}
                  </span>
                  <AssessmentCommonDropdown
                    onChange={handleOnAssessmentChange!}
                    title={state.title}
                    intitalAssessmentId={state.assessmentId}
                    isTimeStampNotNeed={true}
                  />
                </div>
              ) : null}

              {state.title === "Program Performance" &&
                selectedToggle === "Assessments Results" && (
                  <IndustryAssessmentResultDropdown
                    onView={(candidateId, assessmentId) => {
                      fetchTabs(candidateId, assessmentId);
                    }}
                    selectedItems={selectedItem}
                    setSelectedItems={setSelectedItem}
                  />
                )}


            </div>
          )}

        {/* Skills Timeline OR Progress Timeline + Overall Progress → Line Chart */}
        {(selectedToggle === "Skills Timeline" ||
          (selectedToggle === "Progress Timeline" &&
            selectedSlideBar === "Overall Progress")) && (
            <div
              style={{
                marginTop: "20px",
                marginRight: "15px",
                height: selectedToggle === "Skills Timeline" ? "78vh" : "70vh",
                overflowY: "auto", // ✅ enables vertical scroll
                // optional: space so scrollbar doesn’t overlap content
                boxSizing: "border-box",
                scrollBehavior: "smooth",
              }}
            >
              <LineChartComponent
                heading={
                  state.title === "Jozuna Skills Performance"
                    ? "Jozuna Skills Performance"
                    : state.title === "Curriculum Performance"
                      ? "Curriculum Performance"
                      : "Program Performance"
                }
                tittle={selectedSlideBar}
                toogle={selectedToggle}
                chartConfigs={
                  state.title === "Jozuna Skills Performance"
                    ? chartConfigs
                    : chartConfigs
                }
              />
            </div>
          )}

        {/* Progress Timeline + Concepts Performance → Text */}
        {selectedToggle === "Progress Timeline" &&
          selectedSlideBar === "Concepts Performance" && (
            <div
              style={{
                // backgroundColor:"blue",
                marginTop: "20px",
                height: "68vh",
                overflowY: "auto", // ✅ enables vertical scroll
                // optional: space so scrollbar doesn’t overlap content
                boxSizing: "border-box",
                marginRight: "15px",
              }}
            >
              <SimpleLineChart
                charts={chartCPConfigs}
                heading={
                  state.title === "Jozuna Skills Performance"
                    ? "Jozuna Skills Performance"
                    : state.title === "Curriculum Performance"
                      ? "Curriculum Performance"
                      : "Program Performance"
                }
              />
            </div>
          )}

        {/* Assessments Results */}
        {selectedToggle === "Assessments Results" &&
          (() => {
            if (state.title === "Jozuna Skills Performance") {
              return (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      margin: "25px",
                      marginTop: "10px",
                      marginBottom: "10px",
                      color: "#444444",
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    <span style={{ marginTop: "8px" }}>
                      Select your assessment:{" "}
                    </span>
                    <AssessmentCommonDropdown
                      onChange={handleOnAssessmentChange!}
                      title={state.title}
                      intitalAssessmentId={state?.assessmentId}
                    />
                  </div>
                  <div>
                    {componentsToShow?.length > 0 ? (
                      componentsToShow
                    ) : (
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "500",
                          color: "#999",
                          display: "flex",
                          flexDirection: "column", // stack vertically
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={illustratorImg}
                          style={{
                            height: "400px",
                            width: "470px",
                            marginBottom: "20px",
                          }}
                          alt="No Data"
                        />
                        <span
                          style={{
                            fontFamily: "MazzardMedium",
                            color: "#272727",
                          }}
                        >
                          No assessment results{" "}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            }
            if (
              selectedSlideBarRes === "Overall Results"
              // ||
              // selectedSlideBar === "Overall Progress"
            ) {
              return (
                <div style={{ height: "70vh", marginTop: "30px" }}>
                  {componentsToShow?.length > 0 ? (
                    componentsToShow
                  ) : (
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#999",
                        display: "flex",
                        flexDirection: "column", // stack vertically
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={illustratorImg}
                        style={{
                          height: "400px",
                          width: "470px",
                          marginBottom: "20px",
                        }}
                        alt="No Data"
                      />
                      <span
                        style={{
                          fontFamily: "MazzardMedium",
                          color: "#272727",
                        }}
                      >
                        No overall results{" "}
                      </span>
                    </div>
                  )}
                </div>
              );
            }

            if (
              (selectedSlideBar === "View Concept Analytics" ||
                selectedSlideBarRes === "View Concept Analytics") &&
              state.title === "Curriculum Performance"
            ) {
              return (
                <div>
                  {assessmentData?.domain_scores &&
                    assessmentData.domain_scores.some(
                      (item) => (item.concept_scores?.length ?? 0) > 0,
                    ) ? (
                    <div
                      style={{
                        marginTop: "30px",
                        marginRight: "0px",
                        display: "grid",
                        // gridTemplateColumns:
                        //       validAssessments.length === 1
                        //         ? "1fr"
                        //         : "repeat(2, 1fr)",
                        gridTemplateColumns: shouldUseFullWidth
                          ? "1fr"
                          : "repeat(2, 1fr)",

                        gap: "20px",
                        maxHeight: shouldUseFullWidth ? "" : "60vh", // ✅ fixed height for scroll
                        overflowY: "auto", // ✅ vertical scrolling
                        paddingRight: "0px", // space so scrollbar won’t overlap content
                        paddingBottom: "20px",
                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll on iOS
                        // backgroundColor:"red"
                      }}
                    >
                      {[
                        ...(assessmentData.domain_scores ?? []),
                        // ...(assessmentData.domain_scores ?? []),
                      ]
                        .filter(
                          (item) => (item.concept_scores?.length ?? 0) > 0,
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            style={{
                              border: "none",
                              borderRadius: "8px",
                              padding: "10px",
                              paddingRight: "0",
                              width: shouldUseFullWidth ? "99%" : "600px",
                              backgroundColor: "#ebf3ff",
                              marginRight: "0",
                            }}
                          >
                            {/* Title */}
                            <h4
                              style={{
                                marginBottom: "10px",
                                fontFamily: "Mazzard",
                                fontWeight: "600",
                                color: "#2b384a",
                                fontSize: "16px",
                              }}
                            >
                              {item.domain_name}
                            </h4>

                            {/* Chart */}
                            <ChartComponent
                              key={`${item.domain_id}-${shouldUseFullWidth}`}
                              data={item.concept_scores ?? []}
                              barsToShows={
                                validAssessments.length === 1 ? true : false
                              }
                            />
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#999",
                        display: "flex",
                        flexDirection: "column", // stack vertically
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={illustratorImg}
                        style={{
                          height: "400px",
                          width: "470px",
                          marginBottom: "20px",
                        }}
                        alt="No Data"
                      />
                      <span
                        style={{
                          fontFamily: "MazzardMedium",
                          color: "#272727",
                        }}
                      >
                        No view concept analytics{" "}
                      </span>
                    </div>
                  )}
                </div>
              );
            } else if (
              (selectedSlideBar === "View Concept Analytics" ||
                selectedSlideBarRes === "View Concept Analytics") &&
              state.title === "Program Performance"
            ) {
              return (
                <div>
                  {assessmentData?.domain_scores &&
                    assessmentData.domain_scores.some(
                      (item) => (item.concept_scores?.length ?? 0) > 0,
                    ) ? (
                    <div
                      // style={{
                      //   marginTop: "30px",
                      //   marginRight: "20px",
                      //   display: "grid",
                      //   gridTemplateColumns: "repeat(2, 1fr)", // 2 charts per row
                      //   gap: "20px",
                      //   maxHeight: "68vh", // ✅ fixed height for scroll
                      //   overflowY: "auto", // ✅ vertical scrolling
                      //   paddingRight: "10px", // space so scrollbar won’t overlap content
                      //   paddingBottom: "20px",
                      //   WebkitOverflowScrolling: "touch", // ✅ smooth scroll on iOS
                      // }}
                      style={{
                        marginTop: "30px",
                        marginRight: "0px",
                        display: "grid",
                        // gridTemplateColumns:
                        //       validAssessments.length === 1
                        //         ? "1fr"
                        //         : "repeat(2, 1fr)",
                        gridTemplateColumns: shouldUseFullWidth
                          ? "1fr"
                          : "repeat(2, 1fr)",

                        gap: "20px",
                        maxHeight: shouldUseFullWidth ? "" : "60vh", // ✅ fixed height for scroll
                        overflowY: "auto", // ✅ vertical scrolling
                        paddingRight: "0px", // space so scrollbar won’t overlap content
                        paddingBottom: "20px",
                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll on iOS
                        // backgroundColor:"red"
                      }}
                    >
                      {[...(assessmentData.domain_scores ?? [])]
                        .filter(
                          (item) => (item.concept_scores?.length ?? 0) > 0,
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            style={{
                              border: "none",
                              borderRadius: "8px",
                              padding: "10px",
                              paddingRight: "0",
                              width: shouldUseFullWidth ? "1230px" : "600px",
                              backgroundColor: "#ebf3ff",
                              marginRight: "0",
                            }}
                          >
                            {/* Title */}
                            <h4
                              style={{
                                marginBottom: "10px",
                                fontFamily: "Mazzard",
                                fontWeight: "600",
                                color: "#2b384a",
                                fontSize: "16px",
                              }}
                            >
                              {item.domain_name}
                            </h4>

                            {/* Chart */}
                            <ChartComponent
                              key={`${item.domain_id}-${shouldUseFullWidth}`}
                              data={item.concept_scores ?? []}
                              barsToShows={
                                validAssessments.length === 1 ? true : false
                              }
                            />
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#999",
                        display: "flex",
                        flexDirection: "column", // stack vertically
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={illustratorImg}
                        style={{
                          height: "400px",
                          width: "470px",
                          marginBottom: "20px",
                        }}
                        alt="No Data"
                      />
                      <span
                        style={{
                          fontFamily: "MazzardMedium",
                          color: "#272727",
                        }}
                      >
                        No view concept analytics{" "}
                      </span>
                    </div>
                  )}
                </div>
              );
            }

            return (
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  color: "#999",
                  display: "flex",
                  flexDirection: "column", // stack vertically
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <img
                  src={illustratorImg}
                  style={{
                    height: "400px",
                    width: "470px",
                    marginBottom: "20px",
                  }}
                  alt="No Data"
                />
                <span style={{ fontFamily: "MazzardMedium", color: "#272727" }}>
                  No view concept analytics{" "}
                </span>
              </div>
            );
          })()}
        {selectedToggle === "Pop-Quiz" &&
          (() => {
            //  if (
            //     // (selectedSlideBar === "View Concept Analytics" ||
            //     //   selectedSlideBarRes === "View Concept Analytics") &&
            //     state.title === "Program Performance"
            //   ) {
            //     return (
            //       <div>
            //         {
            //         gradedPopQuizData?.graded_popquiz_data &&
            //         gradedPopQuizData.graded_popquiz_data.some(
            //           (item) => (item.concept_scores?.length ?? 0) > 0
            //         )
            //         ? (
            //           <div
            //             // style={{
            //             //   marginTop: "30px",
            //             //   marginRight: "20px",
            //             //   display: "grid",
            //             //   gridTemplateColumns: "repeat(2, 1fr)", // 2 charts per row
            //             //   gap: "20px",
            //             //   maxHeight: "68vh", // ✅ fixed height for scroll
            //             //   overflowY: "auto", // ✅ vertical scrolling
            //             //   paddingRight: "10px", // space so scrollbar won’t overlap content
            //             //   paddingBottom: "20px",
            //             //   WebkitOverflowScrolling: "touch", // ✅ smooth scroll on iOS
            //             // }}
            //             style={{
            //               marginTop: "30px",
            //               marginRight: "0px",
            //               display: "grid",
            //               // gridTemplateColumns:
            //               //       validAssessments.length === 1
            //               //         ? "1fr"
            //               //         : "repeat(2, 1fr)",
            //               gridTemplateColumns: shouldUseFullWidth
            //                 ? "1fr"
            //                 : "repeat(2, 1fr)",

            //               gap: "20px",
            //               maxHeight: shouldUseFullWidth ? "" : "60vh", // ✅ fixed height for scroll
            //               overflowY: "auto", // ✅ vertical scrolling
            //               paddingRight: "0px", // space so scrollbar won’t overlap content
            //               paddingBottom: "20px",
            //               WebkitOverflowScrolling: "touch", // ✅ smooth scroll on iOS
            //               // backgroundColor:"red"
            //             }}
            //           >
            //             {[
            //               ...(gradedPopQuizData.graded_popquiz_data ??
            //                 []),
            //             ]
            //               .filter((item) => (item.concept_scores?.length ?? 0) > 0)
            //               .map((item, index) => (
            //                 <div
            //                   key={index}
            //                   style={{
            //                     border: "none",
            //                     borderRadius: "8px",
            //                     padding: "10px",
            //                     paddingRight: "0",
            //                     width: shouldUseFullWidth ? "1230px" : "600px",
            //                     backgroundColor: "#ebf3ff",
            //                     marginRight: "0",
            //                   }}
            //                 >
            //                   {/* Title */}
            //                   <h4
            //                     style={{
            //                       marginBottom: "10px",
            //                       fontFamily: "Mazzard",
            //                       fontWeight: "600",
            //                       color: "#2b384a",
            //                       fontSize: "16px",
            //                     }}
            //                   >
            //                     {item.course_name}
            //                   </h4>

            //                   {/* Chart */}
            //                   <ChartComponent
            //                     key={`${item.course_id}-${shouldUseFullWidth}`}
            //                     data={item.concept_scores ?? []}
            //                     barsToShows={
            //                       validAssessments.length === 1 ? true : false
            //                     }
            //                   />
            //                 </div>
            //               ))}
            //           </div>
            //         ) :
            //         (
            //           <div
            //             style={{
            //               fontSize: "18px",
            //               fontWeight: "500",
            //               color: "#999",
            //               display: "flex",
            //               flexDirection: "column", // stack vertically
            //               justifyContent: "center",
            //               alignItems: "center",
            //               width: "100%",
            //               textAlign: "center",
            //             }}
            //           >
            //             <img
            //               src={illustratorImg}
            //               style={{
            //                 height: "400px",
            //                 width: "470px",
            //                 marginBottom: "20px",
            //               }}
            //               alt="No Data"
            //             />
            //             <span
            //               style={{ fontFamily: "MazzardMedium", color: "#272727" }}
            //             >
            //               No graded pop-quiz{" "}
            //             </span>
            //           </div>
            //         )}
            //       </div>
            //     );
            //   }
            if (
              state.title === "Curriculum Performance" ||
              state.title === "Program Performance" // ||
              // selectedSlideBar === "Overall Progress"
            ) {
              return (
                <div style={{ height: "60vh", marginTop: "10px" }}>
                  {componentsToShowGP?.length > 0 ? (
                    componentsToShowGP
                  ) : (
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#999",
                        display: "flex",
                        flexDirection: "column", // stack vertically
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={illustratorImg}
                        style={{
                          height: "400px",
                          width: "470px",
                          marginBottom: "20px",
                        }}
                        alt="No Data"
                      />
                      <span
                        style={{
                          fontFamily: "MazzardMedium",
                          color: "#272727",
                        }}
                      >
                        No overall results{" "}
                      </span>
                    </div>
                  )}
                </div>
              );
            }
          })()}
        {showOverlay && selectedQuiz && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.4)",
              zIndex: 1000,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "20px",
                width: "80%",
                maxHeight: "85vh",
                overflowY: "auto",
              }}
            >
              {/* Header */}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3
                  style={{
                    fontFamily: "Mazzard",
                    fontWeight: 600,
                    fontSize: "20px",
                    color: "#2d2d2d",
                  }}
                >
                  Detailed Concept Analytics{" "}
                </h3>
                <img
                  style={{ width: "30px", height: "30px", cursor: "pointer" }}
                  src={CloseIcon}
                  onClick={() => setShowOverlay(false)}
                />
              </div>
              <BlueHorizontalDivider bgColor="#EAEAEA" />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "16px",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {/* Title */}
                  <p
                    style={{
                      color: "#344054",
                      fontSize: "18px",
                      fontWeight: 600,
                      fontFamily: "Mazzard",
                      margin: 0,
                    }}
                  >
                    {selectedQuiz.course_name}{" "}
                  </p>

                  {/* Icon Row */}
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      marginTop: "6px",
                      color: "#344054",
                      fontSize: "14px",
                      fontWeight: 400,
                      fontFamily: "Mazzard",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <img src={VideoImg} alt="videos" />
                      <span>
                        {selectedQuiz.total_videos}{" "}
                        {selectedQuiz.total_videos === 1 ? "Video" : "Videos"}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <img src={DocImg} alt="videos" />
                      <span>
                        {selectedQuiz.total_files}{" "}
                        {selectedQuiz.total_files === 1 ? "File" : "Files"}
                      </span>
                    </div>

                  
                  </div> */}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      color: "#344054",
                      fontSize: "15px",
                      fontWeight: 600,
                      fontFamily: "Mazzard",
                      marginRight: "6px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Overall Score:
                  </span>
                  <div
                    className="industryresults-exam-score"
                    style={{
                      backgroundColor:
                        getScroeBoardResult(selectedQuiz.pop_quiz_avg).backgroundColor,
                      marginRight: "15px",
                    }}
                  >
                    <p
                      style={{
                        color: getScroeBoardResult(selectedQuiz.pop_quiz_avg).textColor,
                        margin: 0,
                      }}
                    >
                      {selectedQuiz.pop_quiz_avg}%
                    </p>
                    <img
                      src={getScroeBoardResult(selectedQuiz.pop_quiz_avg).bulbImage}
                      className="industryresults-score-bulb"
                      alt="bulb"
                    />
                  </div>
                </div>
              </div>
              {/* Charts */}

              {selectedQuiz &&
                (selectedQuiz.concept_scores?.length ?? 0) > 0 ? (
                <div
                  style={{
                    marginTop: "20px",
                    backgroundColor: CommonUtils.getIndustryScoreColors(
                      selectedQuiz.pop_quiz_avg,
                    ).backgroundColor,
                    borderRadius: "8px",
                    padding: "16px",
                  }}
                >
                  {/* <h4
                    style={{
                      fontFamily: "Mazzard",
                      fontWeight: 600,
                      fontSize: "16px",
                      marginBottom: "10px",
                    }}
                  >
                    {selectedQuiz.course_name}
                  </h4> */}

                  <ChartComponent
                    data={selectedQuiz.concept_scores}
                    barsToShows={true}
                  />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    // height: "100vh", // full page height
                    textAlign: "center",
                  }}
                >
                  <img
                    src={illustratorImg}
                    alt="No Data"
                    style={{ height: "300px", width: "350px" }}
                  />
                  <p>No chart data</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewDetailsOverlay;